module.exports = __webpack_public_path__ + "static/media/surprise.5689fda3.svg";